import { Box, Step, StepButton, Stepper } from '@mui/material';
import { isEmpty } from 'lodash';
import { PaymentForm } from '../../interfaces/Checkout/PaymentForm';
import {
  CheckoutStep,
  checkoutSteps,
  validateAddress,
  validatePayment,
  validateProfile,
} from './utils';

type CheckoutStepperProps = {
  form: PaymentForm;
  currentStep: CheckoutStep;
  setCurrentStep: (step: CheckoutStep) => void;
};

export const CheckoutStepper = ({
  form,
  currentStep,
  setCurrentStep,
}: CheckoutStepperProps) => {
  const profileErrors = validateProfile(form);
  const addressErrors = validateAddress(form);
  const paymentErrors = validatePayment(form);

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper nonLinear activeStep={checkoutSteps.indexOf(currentStep)}>
        <Step completed={isEmpty(profileErrors)}>
          <StepButton color='inherit' onClick={() => setCurrentStep('profile')}>
            Kişisel Bilgiler
          </StepButton>
        </Step>

        <Step completed={isEmpty(addressErrors)}>
          <StepButton color='inherit' onClick={() => setCurrentStep('address')}>
            Adres Bilgileri
          </StepButton>
        </Step>

        <Step completed={isEmpty(paymentErrors)}>
          <StepButton color='inherit' onClick={() => setCurrentStep('payment')}>
            Ödeme Seçenekleri
          </StepButton>
        </Step>
      </Stepper>
    </Box>
  );
};
